<script setup>
const router = useRouter();

const steps = [
  {
    icon: "Shop",
    text: "添加店铺",
  },
  {
    icon: "DocumentAdd",
    text: "发起合同",
  },
  {
    icon: "Clock",
    text: "等待审批",
  },
  // { icon: "/icons/report.png", text: "提报活动" },
  // { icon: "/icons/live.png", text: "商品上播" },
];
const cards = [
  {
    icon: "Shop",
    title: "添加店铺",
    description: "前往查看添加的店铺列表或添加要合作的店铺",
    buttonText: "店铺列表",
    path: "/merchant/shop",
  },
  {
    icon: "DocumentAdd",
    title: "发起合同",
    description: "前往查看发起的合同列表或发起合同",
    buttonText: "合同列表",
    path: "/welfare/index",
  },
  // {
  //   icon: "/icons/report-event.png",
  //   title: "提报活动",
  //   description: "您可以浏览活动信息，入驻审核通过后可提报活动",
  //   buttonText: "立即查看",
  //   path: "report",
  // },
];
</script>

<template>
  <div>
    <page-main>
      <el-scrollbar style="height: calc(100vh - 250px)">
        <div class="page-container">
          <!-- 顶部流程图 -->
          <div class="steps-bar" v-if="0">
            <div class="step" v-for="(step, index) in steps" :key="index">
              <div class="step-content">
                <component
                  :is="step.icon"
                  :size="6"
                  :color="'#409EFF'"
                ></component>

                <span>{{ step.text }}</span>
              </div>
            </div>
          </div>

          <el-steps :space="200" active="0" simple class="steps-bar">
            <el-step title="添加店铺">
              <template #icon>
                <!-- <el-icon size="20" color="#909399"><Shop /></el-icon> -->
              </template>
              <template #title>
                <span style="color: #909399"> ① 添加店铺</span></template
              >
            </el-step>

            <el-step title="发起合同">
              <template #icon>
                <!-- <el-icon size="20" color="#909399"><DocumentAdd /></el-icon> -->
              </template>
              <template #title>
                <span style="color: #909399"> ② 发起合同</span></template
              >
            </el-step>
            <el-step title="等待审批">
              <template #icon>
                <!-- <el-icon size="20" color="#909399"><Clock /></el-icon> -->
              </template>
              <template #title>
                <span style="color: #909399"> ③ 等待审批</span></template
              >
            </el-step>
          </el-steps>

          <!-- 中间卡片区域 -->
          <div class="cards-container">
            <div class="card" v-for="(card, index) in cards" :key="index">
              <!-- <img :src="card.icon" alt="" class="card-icon" /> -->
              <!-- <el-icon size="60"><Shop /></el-icon> -->
              <component :is="card.icon" :size="20" color="#409EFF"></component>

              <h3 class="card-title">{{ card.title }}</h3>
              <p class="card-description">{{ card.description }}</p>
              <button class="card-button" @click="() => router.push(card.path)">
                {{ card.buttonText }}
              </button>
            </div>
          </div>
        </div>
      </el-scrollbar>
    </page-main>
  </div>
</template>

<style scoped>
.page-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  padding: 20px;
  min-width: 960px;
}

.steps-bar {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  max-width: 1400px;
  margin-bottom: 40px;
  background-color: #f9f9f9;
  padding: 20px 20%;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: relative;
}

.step {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  flex: 1;
}

.step-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.cards-container {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  width: 100%;
  max-width: 1400px;
}

.card {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background-color: var(--g-container-bg);
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.card-icon {
  width: 60px;
  height: 60px;
  margin-bottom: 16px;
}

.card-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 8px;
}

.card-description {
  font-size: 14px;
  color: #666;
  margin-bottom: 16px;
}

.card-button {
  padding: 10px 20px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.card-button:hover {
  background-color: #0056b3;
}
</style>
